import { createCRUDHook } from './createCRUDHook';
import {
  PartCategoryDto,
  JsonPatch,
  FilterOptionModel,
  PartCategoryHelpTextDto,
} from 'utils/models';
import {
  FILTERED_ENTITIES,
  TBL_PART_CATEGORY,
  TBL_PART_CATEGORY_HELP_TEXT,
} from './apiEndPoints';
import { AxiosResponse } from 'axios';
import { prepareQueryParams } from 'utils';

interface PartCategoryCustomOperations {
  getPartCategoryHelpTextDataByFE: (
    filteredEntities: FilterOptionModel
  ) => Promise<PartCategoryHelpTextDto>;
  getPartCategoryHelpTextData: () => Promise<PartCategoryHelpTextDto[]>;
  addPartCategoryHelpTextData: (
    param: PartCategoryHelpTextDto
  ) => Promise<PartCategoryHelpTextDto>;
  updatePartCategoryHelpTextData: (
    param: JsonPatch[],
    id: number
  ) => Promise<AxiosResponse>;
  deletePartCategoryHelpTextData: (id: number) => Promise<boolean>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  PartCategoryDto,
  PartCategoryDto[],
  PartCategoryCustomOperations
>({
  entityName: 'PartCategory',
  endpoint: TBL_PART_CATEGORY,

  customOperations: (auth) => ({
    getPartCategoryHelpTextDataByFE: async (filteredEntities) => {
      const res = await auth.makeAuthenticatedGet(
        TBL_PART_CATEGORY_HELP_TEXT +
          FILTERED_ENTITIES +
          `?${prepareQueryParams(filteredEntities)}`
      );
      return res.data;
    },

    getPartCategoryHelpTextData: async () => {
      const res = await auth.makeAuthenticatedGet(TBL_PART_CATEGORY_HELP_TEXT);
      return res.data;
    },

    addPartCategoryHelpTextData: async (param) => {
      const res = await auth.makeAuthenticatedPost(
        TBL_PART_CATEGORY_HELP_TEXT,
        param
      );
      return res.data;
    },

    updatePartCategoryHelpTextData: async (param, id) => {
      const res = await auth.makeAuthenticatedPatch(
        `${TBL_PART_CATEGORY_HELP_TEXT}/${id}`,
        param
      );
      return res;
    },

    deletePartCategoryHelpTextData: async (id) => {
      const res = await auth.makeAuthenticatedDelete(
        `${TBL_PART_CATEGORY_HELP_TEXT}/${id}`
      );
      return res.data;
    },
  }),
});

export const PartCategoryContext = Context;
export const usePartCategoryManager = useManager;
export const usePartCategory = useConsumer;
